module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-category-list row column"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.types), function(type, index) {
    return _c('div', {
      key: ("VT" + (type.id) + "-" + index),
      staticClass: "column small-12 large-6 category",
      class: {
        active: _vm.activeIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.setSearch(index)
        }
      }
    }, [_c('div', {
      staticClass: "inner-content card text-center"
    }, [_c('div', {
      staticClass: "row text-center"
    }, [_c('div', {
      staticClass: "column text-left"
    }, [_c('h2', [_vm._v(_vm._s(type.name))])]), _c('div', {
      staticClass: "column text-right"
    }, [_c('pre', [_vm._v("VT" + _vm._s(type.id))])])]), _c('div', {
      staticClass: "row text-center"
    }, [_c('div', {
      staticClass: "column text-right"
    }, [(_vm.activeIndex === index) ? _c('i', {
      staticClass: "fa fa-trash fa-2x",
      on: {
        "click": _vm.deleteType
      }
    }) : _vm._e()])]), _c('div', {
      staticClass: "row text-center"
    }, [_c('div', {
      staticClass: "column text-left"
    }, [_c('p', [_vm._v(_vm._s(type.description))])])])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8fb4d910!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/VehicleTypesList.vue
// module id = 2634
// module chunks = 1